<template lang="pug">
  .document-form
    b-btn(v-if="!form_shown" size="sm" variant="outline-success"  @click="form_shown = !form_shown") Добавить файл
    b-form(v-if="form_shown")
      .mb-1
        b-form-file(
          :id="file_field_id"
          :value="local_file"
          :input="on_input"
          :state="state"
          size="sm"
          placeholder="Файл"
          trim)
      .mb-1
        b-form-input(
          v-model="local_name"
          size="sm"
          placeholder="Название файла"
          )
      .mb-1
        b-select(
          v-model="local_doc_type"
          :options="doc_type_collection"
          size="sm"
          )

      b-btn(size="sm" variant="success" @click="custom_submit") Загрузить
</template>

<script>
export default {
  name: "DocumentForm",
  props:['linked_id', 'linked_type'],
  data(){
    return {
      key: 'document_form',
      file_field_id: 'file_input',
      local_file: undefined,
      local_name: '',
      local_doc_type: 'file',
      doc_type_collection: ['file', 'voucher', 'invoice'],
      state: undefined,
      form_shown: false,

    }
  },
  methods:{
    on_input(){

    },
    custom_submit(){
      let data = new FormData();
      data.append(`secure_document[file]`, document.getElementById(this.file_field_id).files[0]  );
      data.append(`secure_document[doc_type]`, this.local_doc_type);
      data.append(`secure_document[name]`, this.local_name);
      data.append(`secure_document[linked_id]`, this.linked_id);
      data.append(`secure_document[linked_type]`, this.linked_type);


      let promise = this.$store.dispatch("docs/addDoc", {data});
      promise.then(this.clear_form);
    },
    clear_form(){
      console.log('clear form')
      this.local_file = undefined;
      this.local_doc_type = 'file';
      this.form_shown = false;
    },
  }

}
</script>

<style scoped>

</style>